import button from '@/components/button'
import fileDialog from '@/components/file/dialog'
import { dialogTypes } from '@/components/file/utils'

function renderFileDialog(h) {
  return h(
    fileDialog,
    {
      props: {
        value: this.currentEditFile,
        googleFileURL: this.googleFileURL,
        show: this.showDialog,
        type: dialogTypes.edit
      },
      on: {
        show: event => {
          this.showDialog = event
        },
        input: event => {
          this.currentEditFile = event
        }
      }
    }
  )
}

export default function(h) {
  let component = this.component
  if (this.component === 'button') {
    component = button
  }

  return h(
    component,
    {
      props: this.$_props,
      on: {
        click: () => {
          return this.edit()
        }
      },
      scopedSlots: {
        dialog: () => {
          return renderFileDialog.call(this, h)
        }
      }
    }
  )
}
